import React, { Component } from 'react'
import { Modal, Select } from 'hljd'
import { observer, inject } from 'mobx-react'
import moment from 'moment'

const Option = Select.Option

@inject('listStore')
@observer
class ExportModal extends Component {
  getMonthList = () => {
    const oldest = '2018-06'
    const months = moment().diff(moment(oldest), 'month')

    let monthList = []
    for (let i = 0; i <= months; i++) {
      const date = moment(oldest).add(i, 'month')
      monthList.push({
        value: date.format('YYYY-MM'),
        title: date.format('YYYY年MM月')
      })
    }
    return monthList.reverse()
  }

  render() {
    const {
      exportModalVisible,
      setStoreData,
      exportCustomerByMonth,
      initialMonth,
      selectMonth
    } = this.props.listStore

    return (
      <Modal
        title="导出列表数据"
        visible={exportModalVisible}
        onOk={exportCustomerByMonth}
        onCancel={() =>
          setStoreData([
            { type: 'exportModalVisible', value: false },
            { type: 'selectMonth', value: initialMonth }
          ])
        }
        width={400}
      >
        <div className="text-center" style={{ color: '#333' }}>
          请选择导出月份：<Select
            style={{ width: 200 }}
            value={selectMonth}
            onChange={value => {
              setStoreData([{ type: 'selectMonth', value }])
            }}
          >
            {this.getMonthList().map(({ title, value }) => (
              <Option key={value} value={value}>
                {title}
              </Option>
            ))}
          </Select>
        </div>
      </Modal>
    )
  }
}

export default ExportModal
